module.exports = __webpack_public_path__ + "static/agut-profile-3860c2174a233e1a35ead8855f45e19e.jpg";